/**
 * Iter 70.1 — Social proof metrics for the /plus page.
 *
 * These values are surfaced on `/plus` above the CTA to signal that Gully
 * is an active, trusted product. The user's spec forbids new backend
 * endpoints AND fake numbers, so this constants file is the sanctioned
 * knob: the founder updates it from real dashboard totals whenever the
 * numbers meaningfully change.
 *
 * How to refresh (source of truth is /admin, no queries duplicated):
 *   · totalPlayers   → `/admin` → total_users tile
 *   · totalReviews   → `/admin` → total video reviews completed
 *   · totalMessages  → `/admin` → total web_messages count
 *   · countries      → distinct country codes with user_billing/checkouts
 *
 * Rules:
 *   · NEVER inflate — under-count and grow into the number.
 *   · If a metric can't be defended with a screenshot from /admin,
 *     set it to null. `PlusSocialProof` will simply skip null lines,
 *     never render a placeholder.
 *   · The `+` suffix is added by the render layer; store the raw
 *     rounded-down floor (700 → renders as "700+").
 *   · Countries list must reflect real geographies seen in Stripe /
 *     signup logs. Order most-populated first.
 */
export const SOCIAL_PROOF = {
  // Rounded-down floor of live totals — update from /admin.
  totalPlayers:  700,      // e.g. 731 → 700
  totalReviews:  500,      // completed video reviews
  totalMessages: 4000,     // chat turns across all sessions
  // ISO country names (human-readable). null / [] both render nothing.
  countries: ["India", "Australia", "England", "Canada"],
  // Last founder-verified date — kept so future you knows how stale
  // the numbers are. Format: YYYY-MM-DD. Purely a comment for humans.
  lastVerifiedAt: "2026-02-15",
};
